import { Component } from '@theme/component';
import { CartAddEvent } from '@theme/events';

/**
 * Katua cart drawer upsell ("Agrega a tu carrito"). Adds the chosen variant to the cart and
 * dispatches the theme's CartAddEvent with the cart sections, so cart-items-component morphs the
 * drawer (the added product then leaves this list because it is already in the cart).
 *
 * Markup is re-rendered with the drawer, so handlers query from the clicked button.
 */
class KatuaCartUpsell extends Component {
  /**
   * @param {MouseEvent} event
   */
  async add(event) {
    const button = event.target;
    if (!(button instanceof HTMLButtonElement) || button.getAttribute('aria-busy') === 'true') return;

    const card = button.closest('[data-upsell-card]');
    const select = card?.querySelector('[data-variant-select]');
    const variantId = select instanceof HTMLSelectElement ? select.value : button.dataset.variantId;

    if (!variantId) {
      if (select instanceof HTMLSelectElement) {
        select.classList.add('katua-cart-upsell__select--attention');
        select.focus();
        select.addEventListener('change', () => select.classList.remove('katua-cart-upsell__select--attention'), {
          once: true,
        });
      }
      return;
    }

    const status = this.querySelector('[data-upsell-status]');
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : undefined))
      .filter(Boolean);

    /** @type {Record<string, unknown>} */
    const body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (sectionIds.length) body.sections = sectionIds.join(',');

    const cartAddUrl = /** @type {any} */ (window).Theme?.routes?.cart_add_url ?? '/cart/add.js';
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message);

      this.dispatchEvent(
        new CartAddEvent({}, variantId, {
          source: 'katua-cart-upsell',
          itemCount: 1,
          variantId,
          sections: result.sections,
        })
      );
    } catch (error) {
      const message = error instanceof Error && error.message ? error.message : this.dataset.textError ?? '';
      if (status) status.textContent = message;
      button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('katua-cart-upsell')) {
  customElements.define('katua-cart-upsell', KatuaCartUpsell);
}
